import { Sucursal } from "./Sucursal";

export class HistoricoUnidad {
  fechaIngreso: Date;
  idSucursal: number;
  sucursal: string;
  ordenServicio: string;
  proceso: string;
  claveProceso: string;
  idOrdenServicio: string;
  aseguradora: string;
  ajustador: string;
  siniestro: string;
  reporte: string;
  cliente: string;
  contacto: string;
  unidad: string;
  fechaEntrega: Date;
  fechaPromesa: Date;
  manoObraAutorizado: number;
  refaccionesAutorizado: number;
  reparacionesAutorizado: number;
  montoAutorizado: number;
  costoPlan: number;
  costoMP: number;
  costoContableManoObra: number;
  costoContableRefacciones: number;
  utilidad: number;
  porcentaje: number;
  fechaTermino: Date;
  avance: number;
}

export interface ReporteDireccion {
  idOrdenServicio: string;
  ordenServicio: string;
  proceso: string;
  cliente: string;
  tipoServicio: string;
  aseguradora: string;
  fechaIngreso: Date;
  idSucursal: number;
  sucursal: string;
  claveProceso: string;
  ajustador: string;
  siniestro: string;
  reporte: string;
  numeroPoliza: string;
  status: string;
  contacto: string;
  unidad: string;
  estadoUbicCliente: string;
  fechaEntrega?: Date;
  fechaPromesa?: Date;
  fechaNuevoAcuerdo?: Date;
  fechaTermino?: Date;
  fechaSeguro?: Date;
  montoAutorizado: number;

  costoMOPresupuesto: number;
  costoRefPresupuesto: number;
  costoRepPresupuesto: number;
  costoTotalPresupuesto: number;
  utilidadPresupuesto: number;
  utilidadPorcPresupuesto: number;

  costoMOPlan: number;
  costoRefPlan: number;
  costoRepPlan: number;
  costoTotalPlan: number;
  utilidadPlan: number;
  utilidadPorcPlan: number;

  costoMOReal: number;
  costoRefReal: number;
  costoRepReal: number;
  costoTotalReal: number;
  utilidadReal: number;
  utilidadPorcReal: number;

  costoPlan: number;
  utilidad: number;
  porcentaje: number;

  manoObraAutorizado: number;
  refaccionesAutorizado: number;
  reparacionesAutorizado: number;
  costoMP: number;
  avance: number;
  avanceCompras: number;
  costoContableManoObra: number;
  costoContableRefacciones: number;

  economico: string;
  modelo: string;
  marca: string;
  numeroSerie: string;
  placas: string;
  magnitud: string;

  numeroFactura: string;
  fechaFactura: string;

  demerito: number;
  deducible: number;

  manoObra: number;
  refaccion: number;
  mesanterior: number;
  facturado: number;
  porFacturar: number;
  mesSiguiente: number;

  presupuesto: number;
  presupuestoAvance: number;

  perdidaTotal: boolean;
  cancelada: boolean;
  diasVencido: number;

  comentarioRecepcion: string;
  comentarioValuacion: string;
  comentarioAutorizacion: string;
  comentarioReparacion: string;
  comentarioAvance: string;
  comentarioTerminada: string;
  comentarioEntrega: string;

  facturasEmitidas: FacturaEmitida[];
}

export interface FacturaEmitida {
  idOrdenServicio: number;
  folio: string;
  tipoFactura: string;
  fechaEmision: Date;
  cobrado: boolean;
}

export class UnidadIngresada {
  nombre: string;
  meses: number[] = [];
  total: number;
  tipoServicio: string;
}

export class UnidadAnual {
  nombre: string;
  meses: number[] = [];
  total: number;
}

export class TotalMes {
  mes: number;
  total: number;
}

export class DetalleUnidadProceso {
  idOrdenServicio: number;
  ordenServicio: string;
  cliente: string;
  aseguradora: string;
  fecha: Date;
}

export class UnidadProceso {
  idProceso: number;
  proceso: string;
  clave: string;
  total: number;
  orden: number;
  unidades: DetalleUnidadProceso[];
}

export class Estimado {
  idOrdenServicio: number;
  ordenServicio: string;
  proceso: string;
  cliente: string;
  tipoServicio: string;
  aseguradora: string;
  siniestro: string;
  reporte: string;
  economico: string;
  magnitud: string;
  avance: number;
  presupuestoAvance: number;
  demerito: number;
  deducible: number;
  manoObra: number;
  refaccion: number;
  mesanterior: number;
  facturado: number;
  porFacturar: number;
  mesSiguiente: number;
  presupuesto: number;
  fechaIngreso: Date;
  fechaPromesa: Date;
  perdidaTotal: boolean;
}

export class AurotizadoAseguradora {
  idOrdenServicio: number;
  ordenServicio: string;
  unidad: string;
  cliente: string;
  reporte: string;
  ubicacion: string;
  montoAutorizado: number;
  montoAutorizadoIva: number;
  fechaIngreso: Date;
  fechaAutorizacion: Date;
  fechaTerminado: Date;
  fechaEntrega: Date;
  ajustador: string;
  telefonoAjustador: string;
}

export class Filter {
  dateFrom: boolean;
  dateTo: boolean;
  export: boolean;
  sucursal: boolean;
}

export class Column {
  header: string;
  field: string;
  hidden: boolean;
  format: string;
  icon: string;
  type: string;
}

export class Reporte {
  nombre: string;
  titulo: string;
  descripcion: string;
  icon: string;
  filter: Filter;
  columns: Column[];
}

export class ReporteGeneral {
  nombre: string;
  fechaEnabled: boolean;
  desde: Date;
  hasta: Date;
  idSucursal: number;
}

export class ImprimirRecepcion {
  ordenServicio: string;
  direccion: string;
  fechaIngreso: Date;
  aseguradora: string;
  siniestro: string;
  reporte: string;
  poliza: string;
  placa: string;
  marca: string;
  modelo: string;
  serie: string;
  kmEntrada: number;
  tipoUnidad: string;
  cliente: string;
  asesor: string;
  gasPorcentaje: number;
  observaciones: string;
  ajustador: string;
}

export class ReporteGlobalMes {
  mes: string;
  venta: number;
  costo: number;
  utilidad: number;
  porcentajeUtilidad: number;
  idSucursal: number;
  sucursal: string;
}

export class ReporteFacturacion {
  idOrdenServicio: number;
  ordenServicio: string;
  proceso: string;
  aseguradora: string;
  idsucursal: number;
  cliente: string;
  unidad: string;
  factura: string;
  fechaEmision: Date;
  fechaCobro: Date;
  tipoFactura: string;
  observaciones: string;
  netoFacturado: number;
  metodoPago: string;
  cobrado: boolean;
  diasTranscurridos: number;
}

export class FacturadoMesSucursal {
  idSucursal: number;
  sucursal: string;
  facturado: number;
  cobrado: number;
}

export class FacturadoMes {
  ordenMes: number;
  mes: string;
  facturado: number;
  cobrado: number;
  general: number;
  sucursalesAnual: FacturadoMesSucursal[];
}

export class ReporteFacturadoSucursal {
  idSucursal: number;
  sucursal: string;
  facturado: number;
  cobrado: number;
}

export class ReporteFacturadoAnual {
  sucursales: ReporteFacturadoSucursal[];
  facturadoAnual: FacturadoMes[];
}

/*
    Pendiente por cobrar de Aseguradoras
*/
export class PendienteAseguradoraSucursal {
  idSucursal: number;
  sucursal: string;
  pendiente: number;
}

export class PendienteAseguradora {
  isAseguradora: number;
  aseguradora: string;
  pendiente: number;
  pendientesPorSucursal: PendienteAseguradoraSucursal[];
}

export class ReportePendientesxAseguradora {
  pendientesxAseguradora: PendienteAseguradora[];
  pendientesxSucursal: PendienteAseguradoraSucursal[];
}

export class ReporteUtilidad {
  idOrdenServicio: number;
  ordenServicio: string;
  proceso: string;
  perdidaTotal: boolean;
  cancelada: boolean;
  aseguradora: string;
  cliente: string;
  autorizado: number;
  planTrabajo: number;
  totalCompra: number;
  utilidad: number;
  utilidadPerc: number;
  manoObra: number;
  refacciones: number;
  complemento: number;
  fechaManoObra: Date;
  fechaRefacciones: Date;
  fechaComplemento: Date;
  fechaIngreso: Date;
  observaciones: string;
  costoContableManoObra: number;
  costoContableRefacciones: number;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/reportes.ts